import { useState } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import globals from '../../globals';

const PasswordField = ({onChange, text, label = "Парола", helperText}) => {
    const [focused, setFocused] = useState(false);
    const [value, setValue] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    return (
        <TextField
            id="password"
            type={showPassword ? 'text' : 'password'}
            label={focused || value ? '' : (label || text)}
            variant="outlined"
            value={value}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            onChange={(e) => {
                setValue(e.target.value);
                if (onChange) {
                    onChange(e);
                }
            }}
            helperText={helperText}
            size="medium"
            sx={{
                backgroundColor: globals.colors.backgroundColor,
                borderRadius: 1,
                color: globals.colors.textColor,
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: globals.colors.darkRed,
                    },
                    '&:hover fieldset': {
                        borderColor: globals.colors.darkRed,
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: globals.colors.darkRed,
                    },
                },
            }}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            onClick={() => setShowPassword((prev) => !prev)}
                            edge="end"
                        >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default PasswordField;
